import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import styled from '@mui/material/styles/styled';
import {SectionHeaderProps} from './types';

export const SectionHeader = styled('header')<SectionHeaderProps>`
	background-color: ${({theme}) => theme.palette.primary.main};
	padding: ${({$padding}) => $padding || '23px 16px'};
	display: flex;

	${({theme}) => theme.breakpoints.up('md')} {
		background-color: white;
		padding: 32px 32px 0px;
	}

	${({theme}) => theme.breakpoints.between('sm', 'md')} {
		padding-inline: 120px;
	}
`;

export const SectionContent = styled(Stack)`
	gap: 16px;
	padding: 16px;

	${({theme}) => theme.breakpoints.up('md')} {
		padding: 32px;
	}

	${({theme}) => theme.breakpoints.between('sm', 'md')} {
		padding-inline: 120px;
	}
`;

export const StyledFixedFooter = styled(Box)`
	${({theme}) => theme.breakpoints.down('md')} {
		position: fixed;
		bottom: 0;
		border-top: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
		right: 0;
		left: 0;
		background-color: white;
		z-index: 2;
		padding: 8px 16px;
	}

	${({theme}) => theme.breakpoints.between('sm', 'md')} {
		padding-inline: 120px;
	}
`;

export const StyledBox = styled(Box)`
	padding: 16px;
	margin-bottom: 56px;
	margin-top: auto;

	${({theme}) => theme.breakpoints.up('md')} {
		padding: 32px;
		margin-bottom: 0px;
	}

	${({theme}) => theme.breakpoints.between('sm', 'md')} {
		padding-inline: 120px;
	}
`;
